import React, { Component, Fragment } from "react";
import DataTable from "react-data-table-component";
import FadeLoader from "react-spinners/FadeLoader";
import ClipLoader from "react-spinners/ClipLoader";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import Menu from "@material-ui/core/Menu";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { connect } from "react-redux";
import { css } from "@emotion/core";
import PropTypes from "prop-types";
import Modal from "react-modal";
import moment from "moment";

import "./DataTable.css";

import PlansFooter from "./PlansFooter";
import ContentSearch from "./ContentSearch";
import history from "@safecv/shared/history";
import AppFooter from "@safecv/core/AppFooter";
import MoreOption from "../../shared/MoreOption";
import RetriggerModal from "./RetriggerPopUpModal";

import buildBlueIcon from "@safecv/assets/Images/build_blue.png";
import buildGreyIcon from "@safecv/assets/Images/build_grey.png";
import uparrow from "@safecv/assets/Images/uparrow.png";
import downarrow from "@safecv/assets/Images/downarrow.png";
import Reassign from "@safecv/assets/Images/Reassign.svg";
import Download from "@safecv/assets/Images/Download.png";
import rightarrow from "@safecv/assets/Images/right_arrow.png";
import Cross from "@safecv/assets/Images/cross.png";

import {
  filterPlans,
  PlansDownload,
  CriteriaList,
  PDFDownloader,
  fetchStateList,
  fetchJurisdictionList,
  queryParams,
} from "@safecv/actions/postActions";
import { gridColumnChange } from "@safecv/actions/types";
import { override, msToTime } from "@safecv/shared/sharedFunction";
import { handleURLChange } from "@safecv/shared/urlParams";
import API_CONFIG from "@safecv/src/api-config";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0",
    width: "300px",
    height: "inherit",
    transform: "translate(-50%, -50%)",
  },
};

class PlansDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      modalIsOpen: false,
      file_types: [],
      state: "",
      jurisdictionName: "",
      RetriggerModal: false,
      planName: "",
      status: "",
      inputVal: "",
      source: "",
      stateJurisdiction: [],
      openConfigureView: null,
      planType: "",
      omitColumn: this.props.gridOmitColumns
        ? this.props.gridOmitColumns
        : {
            Plan: false,
            "Job Id": false,
            State: false,
            Jurisdiction: false,
            "Plan Type": false,
            "# Pages": false,
            "AI Run Time": true,
            Source: false,
            "Added on": false,
            "Updated on": true,
            Discipline: false,
            Status: false,
            "PR Status": true,
          },
    };
  }

  handleInputChangeForSearch = (text) => {
    this.setState({ inputVal: text, activePage: 1 }, this.apiCall);
    handleURLChange({ search: text, pageNo: 1 });
  };

  handleStateListChange = (item) => {
    this.setState(
      {
        state: item.label,
        activePage: 1,
        jurisdictionName: "",
      },
      this.apiCall,
      this.props.fetchJurisdictionList(item.value)
      // history.replace({}, "plans", "/plans")
    );

    handleURLChange({ state: item.label, jurisdiction: "", pageNo: 1 });
  };

  handleStatusListChange = (statuses) => {
    this.setState(
      {
        status: statuses.label,
        activePage: 1,
      },
      this.apiCall
    );

    handleURLChange({ status: statuses.label, pageNo: 1 });
  };

  handleSourceListChange = (sourceOfPlan) => {
    this.setState(
      {
        source: sourceOfPlan.label,
        activePage: 1,
      },
      this.apiCall
    );
    handleURLChange({ source: sourceOfPlan.label, pageNo: 1 });
  };

  handleJurisdictionListChange = (item) => {
    this.setState(
      {
        jurisdictionName: item.label,
        activePage: 1,
      },
      this.apiCall
    );
    handleURLChange({ jurisdiction: item.label, pageNo: 1 });
  };

  handlePlanTypeChange = (item) => {
    this.setState(
      {
        planType: item.label,
        activePage: 1,
      },
      this.apiCall
    );
    handleURLChange({ planType: item.label, pageNo: 1 });
  };

  handleSort = (columns, sortDirection) => {
    this.setState(
      {
        order: sortDirection,
        sortby: columns.selector,
      },
      this.apiCall
    );
    handleURLChange({
      sortby: columns.selector,
      order: sortDirection,
      pageNo: this.state.activePage,
    });
  };

  showResult = (
    activepage,
    planname,
    state,
    jurisdictionName,
    source,
    status,
    order,
    sortby,
    planType
  ) => {
    this.setState({ planName: planname });
    const result = queryString.stringify(
      {
        pageNo: activepage,
        pageSize: 6,
        orderBy: sortby,
        planName: planname,
        state: state,
        source: source,
        jurisdiction: jurisdictionName,
        status: status,
        order: order,
        planType,
      },
      {
        skipEmptyString: true,
      }
    );
    this.props.filterPlans(result);
  };

  apiCall = () => {
    this.showResult(
      this.state.activePage - 1,
      this.state.inputVal,
      this.state.state,
      this.state.jurisdictionName,
      this.state.source,
      this.state.status,
      this.state.order,
      this.state.sortby,
      this.state.planType
    );
    const searchParams = queryString.stringify(
      {
        pageNo: this.state.activePage,
        pageSize: 6,
        orderBy: this.state.sortby,
        search: this.state.inputVal,
        state: this.state.state,
        source: this.state.source,
        jurisdiction: this.state.jurisdictionName,
        status: this.state.status,
        order: this.state.order,
        planType: this.state.planType,
      },
      {
        skipEmptyString: true,
      }
    );
    this.props.queryParams(searchParams);
  };

  componentDidMount() {
    this.props.CriteriaList();
    this.props.fetchStateList();
    if (!history.location.search) {
      this.apiCall();
    } else {
      const query = new URLSearchParams(history.location.search);
      this.setState(
        {
          status: query.get("status"),
          source: query.get("source"),
          state: query.get("state"),
          jurisdictionName: query.get("jurisdiction"),
          inputVal: query.get("search"),
          activePage: parseInt(query.get("pageNo")),
          order: query.get("order"),
          sortby: query.get("orderBy"),
          planType: query.get("planType"),
        },
        this.apiCall
      );
    }
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    // to fetch the jurisdiction if present in url
    if (this.props.states !== prevProps.states && this.state.state) {
      let item = this.props.states.filter(
        (state) => state.stateName === this.state.state
      )[0];
      this.props.fetchJurisdictionList(item.id);
    }
  }

  resetFilters = () => {
    this.setState({
      jurisdictionName: "",
      activePage: 1,
      inputVal: "",
      planName: "",
      status: "",
      source: "",
      state: "",
      planType: "",
    });

    history.replace({}, "plans", "/plans");

    const result = queryString.stringify(
      {
        pageNo: 0,
        pageSize: 6,
        orderBy: "updatedDate",
        planName: "",
        state: "",
        source: "",
        jurisdiction: "",
        status: "",
        planType: "",
      },
      {
        skipEmptyString: false,
      }
    );
    this.props.queryParams("");
    this.props.filterPlans(result);
  };

  openModal = (jobId) => {
    this.setState({
      modalIsOpen: true,
      jobId: jobId,
    });

    this.ChangeItem(jobId, -1);
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  OpenRetriggerModal = (jobId) => {
    this.setState({
      RetriggerModal: true,
      jobId: jobId,
    });
  };

  CloseRetriggerModal = () => {
    this.setState({
      RetriggerModal: false,
    });
  };

  handlePageChange = (pageNumber) => {
    this.setState(
      {
        activePage: pageNumber,
        loading: true,
      },
      this.apiCall
    );
    handleURLChange({ pageNo: pageNumber });
  };

  ChangeItem = (jobId, index = -1) => {
    if (index === -1) this.props.PlansDownload(jobId);
    else {
      this.props.PDFDownloader(this.props.planType[index].url);
    }
  };
  openConfigureView = (event) => {
    this.setState({
      openConfigureView: event.currentTarget,
    });
  };

  closeConfigureView = () => {
    this.setState({
      openConfigureView: null,
    });
  };

  gridConfigChange = (column) => {
    this.setState(
      {
        omitColumn: {
          ...this.state.omitColumn,
          [column]: !this.state.omitColumn[column],
        },
      },
      () => {
        this.props.gridColumnChange(this.state.omitColumn);
      }
    );
  };

  render() {
    const { gridOmitColumns } = this.props;
    // const { classes } = this.props;

    let omitColumn = gridOmitColumns ? gridOmitColumns : this.state.omitColumn,
      specificStateJurisdictionList = [];

    const downloadLoader = css`
      display: block;
      margin: 0 15px;
    `;

    const customStyles = {
      rows: {
        style: {
          minHeight: "45px",
          fontFamily: "Lato",
          fontStyle: "normal",
          fontWeight: "normal",
          fontSize: "14px",
          lineHeight: "17px",
          color: "#303B4A",
        },
      },
      headCells: {
        style: {
          minHeight: "45px",
          padding: "4px 0px 4px 20px", // override the cell padding for head cell
          fontFamily: "Lato",
          fontStyle: "normal",
          fontWeight: "Bold",
          fontSize: "14px",
          lineHeight: "17px",
          textAlign: "center",
          color: "#C4C4C7;",
        },
      },
      cells: {
        style: {
          padding: "4px 0px 4px 20px ", // override the cell padding for data cells
          paddingRight: "8px",
          fontFamily: "Lato",
          fontStyle: "normal",
          fontWeight: "normal",
          fontSize: "14px",
          lineHeight: "17px",
          textOverflow: "ellipsis",
          color: "#303B4A",
          textAlign: "none",
        },
      },
      table: {
        style: {
          // border: "1px solid #E1E1E3",
          // width: "95%",
          // margin: "0px 30px 14px 32px",
          height: "auto",
        },
      },
    };
    const sortIcon = (
      <div className="sorticon">
        <img className="uparrow" src={uparrow} alt="arrow" />
        <img className="downarrow" src={downarrow} alt="arrow" />
      </div>
    );

    const IOSSwitch = withStyles((theme) => ({
      root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
      },
      switchBase: {
        padding: 1,
        "&$checked": {
          transform: "translateX(16px)",
          color: theme.palette.common.white,
          "& + $track": {
            backgroundColor: "#4183C5",
            opacity: 1,
            border: "none",
          },
        },
        "&$focusVisible $thumb": {
          color: "#52d869",
          border: "6px solid #fff",
        },
      },
      thumb: {
        width: 24,
        height: 24,
        backgroundColor: "white",
      },
      track: {
        borderRadius: 14,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: "#E2E8F0",
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
      },
      checked: {},
      focusVisible: {},
    }))(({ classes, ...props }) => {
      return (
        <Switch
          focusVisibleClassName={classes.focusVisible}
          disableRipple
          classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          {...props}
        />
      );
    });

    const columns = [
      {
        name: "Plan/ID",
        selector: "planName",
        sortable: true,
        cell: (row) => (
          <div className="table-plan-name" title={row.planName}>
            {row.planName}
          </div>
        ),
        omit: omitColumn["Plan"],
      },
      {
        name: "Job Id",
        selector: "jobId",
        sortable: true,
        width: "7%",
        omit: omitColumn["Job Id"],
      },
      {
        name: "State",
        selector: "state",
        sortable: true,
        width: "7%",
        omit: omitColumn["State"],
      },
      {
        name: "Jurisdiction",
        selector: "jurisdiction",
        sortable: true,
        omit: omitColumn["Jurisdiction"],
      },
      {
        name: "Plan Type",
        selector: "planType",
        sortable: true,
        omit: omitColumn["Plan Type"],
      },
      {
        name: "# Pages",
        selector: "numberOfPages",
        sortable: true,
        width: "6%",
        omit: omitColumn["# Pages"],
      },
      {
        name: "AI Run Time (hours)",
        width: "8%",
        cell: (row) => (
          <div className="table-plan-name">
            {msToTime(
              row.detectProcessingEndTime -
                row.detectProcessingStartTime +
                (row.annotateProcessingEndTime -
                  row.annotateProcessingStartTime)
            )}
          </div>
        ),
        sortable: false,
        omit: omitColumn["AI Run Time"],
      },
      {
        name: "Source",
        selector: "sourceOfPlan",
        sortable: true,
        width: "7%",
        omit: omitColumn["Source"],
      },
      {
        name: "Added on",
        selector: "createdDate",
        cell: (row) => (
          <div
            className="table-plan-name"
            title={moment(row.createdDate).format("MMM DD, YYYY HH:mm")}
          >
            {moment(row.createdDate).format("MMM DD, YYYY HH:mm")}
          </div>
        ),
        sortable: true,
        omit: omitColumn["Added on"],
      },
      {
        name: "Updated on",
        selector: "updatedDate",
        cell: (row) => (
          <div
            className="table-plan-name"
            title={moment(row.updatedDate).format("MMM DD, YYYY HH:mm")}
          >
            {moment(row.updatedDate).format("MMM DD, YYYY HH:mm")}
          </div>
        ),
        sortable: true,
        omit: omitColumn["Updated on"],
      },
      {
        name: "Discipline",
        selector: "disciplines",
        cell: (row) => (
          <div className="table-plan-name" title={row.disciplines.join(", ")}>
            {row.disciplines.join(", ")}
          </div>
        ),
        sortable: false,
        omit: omitColumn["Discipline"],
      },
      {
        name: "Status",
        cell: (row) => (
          <span title={row.description}>
            <Link
              to={{
                pathname:
                  "/plan/" + encodeURIComponent(row.jobId) + "/pdfviewer",
              }}
            >
              {row.displayName}
            </Link>
          </span>
        ),
        width: "10%",
        // grow: 0.7,
        sortable: false,
        omit: omitColumn["Status"],
        style: {
          position: "sticky",
          right: "64px",
          backgroundColor: "#F7FAFC",
          borderLeft: "1px solid #E2E8F0",
        },
        conditionalCellStyles: [
          {
            when: (row) => row.displayName.toLowerCase() === "processing",
            style: {
              color: "#ED8936",
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "17px",
              "&:hover": {
                cursor: "pointer",
              },
            },
          },
          {
            when: (row) => row.displayName.toLowerCase() === "error",
            style: {
              color: "#E53E3E",
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "17px",
              "&:hover": {
                cursor: "pointer",
              },
            },
          },
          {
            when: (row) => row.displayName.toLowerCase() === "discarded",
            style: {
              color: "#CBD5E0",
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "17px",
              "&:hover": {
                cursor: "pointer",
              },
            },
          },
          {
            when: (row) => row.displayName.toLowerCase() === "verify",
            style: {
              color: "#4183C5",
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "17px",
              "&:hover": {
                cursor: "pointer",
              },
            },
          },
          {
            when: (row) => row.displayName.toLowerCase() === "completed",
            style: {
              color: "#38A169",
              fontFamily: "Lato",
              fontStyle: "italic",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "17px",
              "&:hover": {
                cursor: "pointer",
              },
            },
          },
        ],
      },
      {
        name: "",
        button: true,

        cell: (row) => (
          <div className="zero-padding icon-style">
            <Fragment>
              <MoreOption
                OpenRetriggerModal={(id) => this.OpenRetriggerModal(id)}
                openModal={(id) => this.openModal(id)}
                row={row}
                options={
                  row.displayName.toLowerCase() === "error"
                    ? MoreOptionsWithRerun
                    : MoreOptions
                }
              />
              <Link
                to={{
                  pathname:
                    "/plan/" + encodeURIComponent(row.jobId) + "/pdfviewer",
                }}
              >
                <img
                  src={rightarrow}
                  style={{ cursor: "pointer" }}
                  className="arrow-styl"
                  alt="rightarrow"
                ></img>
              </Link>
            </Fragment>
          </div>
        ),
        width: "5%",
        // maxWidth: "50px",
        // minWidth: "70px",
        style: {
          backgroundColor: "#F7FAFC",
          position: "sticky",
          right: 0,
        },
      },
    ];

    if (API_CONFIG.FEATURE_GT_UPLOAD_ENABLED) {
      columns.splice(10, 0, {
        name: "PR Status",
        cell: (row) => <span>{row.prStatus}</span>,
        width: "8%",
        grow: 0.5,
        sortable: false,
        omit: omitColumn["PR Status"],
      });
    }

    const MoreOptions = [
      {
        label: "Download",
        image: Download,
      },
    ];

    const MoreOptionsWithRerun = [
      {
        label: "Download",
        image: Download,
      },
      {
        label: "Re-run",
        image: Reassign,
      },
    ];

    return (
      <div>
        <div className="sweet-loading">
          <FadeLoader
            css={override}
            height={15}
            width={5}
            radius={2}
            margin={2}
            color={"#4183C5"}
            loading={this.props.spinnerLoading}
          />
        </div>
        <ContentSearch
          plans={this.props.plans}
          count={this.props.totalItemsCount}
          activePage={this.props.activePage}
          statuses={this.props.statuses}
          handleStateListChange={this.handleStateListChange}
          handleStatusListChange={this.handleStatusListChange}
          handleJurisdictionListChange={this.handleJurisdictionListChange}
          showResult={this.showResult}
          resetFilters={this.resetFilters}
          stateJurisdiction={
            specificStateJurisdictionList.length > 0
              ? specificStateJurisdictionList
              : this.props.jurisdictions
          }
          state={this.state.state}
          states={this.props.states}
          selectedjurisdiction={this.state.jurisdictionName}
          selected_state={this.state.state}
          selected_status={this.state.status}
          sourceOfPlan={this.props.sourceOfPlan}
          handleInputChange={this.handleInputChangeForSearch}
          inputVal={this.state.inputVal}
          selected_source={this.state.source}
          handleSourceListChange={this.handleSourceListChange}
          planTypeFilterData={this.props.planTypeFilterData}
          handlePlanTypeChange={this.handlePlanTypeChange}
          planType={this.state.planType}
        />
        <div
          style={{ margin: "0px 30px 14px 32px", border: "1px solid #E1E1E3" }}
        >
          <DataTable
            striped
            columns={columns}
            data={this.props.plans}
            customStyles={customStyles}
            onSort={this.handleSort}
            sortIcon={sortIcon}
            noHeader={true}
            className="table-styling"
            persistTableHead={true}
          />
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customModalStyles}
          ariaHideApp={false}
          contentLabel="Download Modal"
        >
          <div className="row" id="bgcolor">
            <div className="col-sm-10" id="custom-padding">
              <h1 id="fsizeupload">Download - {this.state.jobId}</h1>
            </div>
            <div className="col-sm-2" id="custom-styling">
              <img
                src={Cross}
                onClick={this.closeModal}
                alt="quit"
                className="crossStyle"
              />
            </div>
          </div>
          <div className="font-styl-dwnplans">
            {this.props.pdfTypesLoader ? (
              <div className="padding-45">
                <ClipLoader
                  css={downloadLoader}
                  size={15}
                  color={"#4183C5"}
                  loading={true}
                />
              </div>
            ) : (
              this.props.planType.map((option, index) => {
                let loader = this.props.pdfTypes[option.type];
                let className = option.active
                  ? "pdf-download-loader-" + loader
                  : "pdf-download-loader-true";
                return (
                  <div style={{ display: "flex" }}>
                    <ul
                      style={{ cursor: "pointer" }}
                      key={option.name}
                      onClick={() =>
                        option.active &&
                        this.ChangeItem(this.state.jobId, index)
                      }
                      className={className}
                      title={option.description}
                    >
                      {option.name}
                    </ul>
                    <ClipLoader
                      css={downloadLoader}
                      size={15}
                      color={"#4183C5"}
                      loading={loader}
                    />
                  </div>
                );
              })
            )}
            <div className="center">
              <hr></hr>
            </div>
          </div>
        </Modal>

        {this.state.RetriggerModal && (
          <RetriggerModal
            modalIsOpen={this.state.RetriggerModal}
            Modal={this.OpenRetriggerModal}
            jobId={this.state.jobId}
            closeModal={this.CloseRetriggerModal}
          />
        )}

        <div className="row zero-padding table-function">
          <div className="col-sm-6">
            <div
              className="configure-table"
              onClick={(e) => this.openConfigureView(e)}
            >
              <img src={buildBlueIcon} alt="build" className="build-icon" />
              Configure View
            </div>
            <Menu
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              MenuListProps={{
                style: {
                  padding: 0,
                  borderRadius: "15px",
                },
              }}
              id="simple-menu"
              anchorEl={this.state.openConfigureView}
              keepMounted
              open={Boolean(this.state.openConfigureView)}
              onClose={(e) => this.closeConfigureView()}
              PaperProps={{
                style: {
                  borderRadius: "10px",
                },
              }}
            >
              <div className="config-header">
                <img src={buildGreyIcon} alt="build" className="build-icon" />
                Configure View
              </div>
              <div className="config-menu">
                {Object.keys(omitColumn).map((column, index) => {
                  return column !== "PR Status" ||
                    (column === "PR Status" &&
                      API_CONFIG.FEATURE_GT_UPLOAD_ENABLED) ? (
                    <MenuItem key={index}>
                      <div className="config-element">
                        <div className="config-col-name">{column}</div>
                        <FormControlLabel
                          control={
                            <IOSSwitch
                              checked={!omitColumn[column]}
                              onChange={() => this.gridConfigChange(column)}
                              name={column}
                            />
                          }
                          className="config-col-toggle"
                        />
                      </div>
                    </MenuItem>
                  ) : null;
                })}
              </div>
            </Menu>
          </div>
          <div className="col-sm-6">
            <PlansFooter
              plans={this.props.plans}
              handlePageChange={this.handlePageChange}
              activePage={this.state.activePage}
              totalItemsCount={this.props.totalItemsCount}
              itemsCountPerPage={this.props.itemsCountPerPage}
            />
          </div>
        </div>
        <AppFooter className="footer" />
      </div>
    );
  }
}

PlansDataTable.propTypes = {
  plans: PropTypes.array.isRequired,
};

const mapStatetoProps = (state) => {
  return {
    plans: state.plans.plans,
    totalPages: state.plans.totalPages,
    totalItemsCount: state.plans.totalItemsCount,
    itemsCountPerPage: state.plans.itemsCountPerPage,
    searchPlans: state.plans.searchPlans,
    spinnerLoading: state.plans.spinnerLoading,
    states: state.criteria.states,
    jurisdictions: state.criteria.jurisdictions,
    planType: state.plans.file_type,
    statuses: state.criteria.status,
    sourceOfPlan: state.criteria.sourceOfPlan,
    pdfTypes: state.plans.pdfTypes,
    gridOmitColumns: state.plans.gridOmitColumns,
    pdfTypesLoader: state.plans.pdfTypesLoader,
    planTypeFilterData: state.criteria.planTypeFilterData,
  };
};

const mapDispatchtoProps = (dispatch) => {
  return {
    filterPlans: (e) => {
      dispatch(filterPlans(e));
    },
    PlansDownload: (jobId) => {
      dispatch(PlansDownload(jobId));
    },
    CriteriaList: () => {
      dispatch(CriteriaList());
    },
    PDFDownloader: (url) => {
      dispatch(PDFDownloader(url));
    },
    gridColumnChange: (columns) => {
      dispatch(gridColumnChange(columns));
    },
    fetchStateList: () => {
      dispatch(fetchStateList());
    },
    fetchJurisdictionList: (state_id) => {
      dispatch(fetchJurisdictionList(state_id));
    },
    queryParams: (query) => {
      dispatch(queryParams(query));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(PlansDataTable);
